<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['ordinal-recruitment']['width']" [height]="class['ordinal-recruitment']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">           
          <div class="editor-field-body">
           
            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    [staticdata]="staticdata"
                    [textContentClass]="class['ordinal-recruitment__content']"
                    [textWrapperClass]="class['ordinal-recruitment__wrapper']"
                    >
            </app-text-format-config>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['ordinal-recruitment__content']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['ordinal-recruitment__content']['letter-spacing'] = $event+'px'" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['ordinal-recruitment__content']['letter-spacing'] | vhnumber"
                        (ngModelChange)="class['ordinal-recruitment__content']['letter-spacing'] = $event+'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="this.class['ordinal-recruitment__content']['line-height']" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['ordinal-recruitment__content']['line-height']" (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>

              </div>
            </div>
            <div class="field-row" *ngIf="config['ordinal-recruitment_type'] == 'Blockquote'">
              <!-- Blockquote - Thụt lề -->
              <div class="config-font">
                <div class="config-name mb-0">
                  <p>{{'thut_le' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="100"
                    [ngModel]="class['ordinal-recruitment__content']['padding-left'] | vhnumber"
                    (ngModelChange)="class['ordinal-recruitment__content']['padding-left'] = $event+'px'" (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="1" [nzMax]="100" [ngModel]="class['ordinal-recruitment__content']['padding-left'] | vhnumber"
                  (ngModelChange)="class['ordinal-recruitment__content']['padding-left'] = $event+'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <!-- Blockquote - Kích thước viền -->
              <div class="config-font">
                <div class="config-name mb-0">
                  <p>{{'kich_thuoc_vien' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="20"
                    [ngModel]="class['ordinal-recruitment__content']['border-left-width'] | vhnumber"
                    (ngModelChange)="class['ordinal-recruitment__content']['border-left-width'] = $event+'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="1" [nzMax]="100" [ngModel]="class['ordinal-recruitment__content']['border-left-width'] | vhnumber"
                  (ngModelChange)="class['ordinal-recruitment__content']['border-left-width'] = $event+'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <div class="config-font">
                <div class="config-name">
                  <p>{{'mau_vien' | translate}}</p>
                  <input type="button"  class="input-color" [style.background]="class['ordinal-recruitment__content']['border-left-color']"
                    [cpOKButton]="true" [(colorPicker)]="class['ordinal-recruitment__content']['border-left-color']" (colorPickerClose)="updateClass()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- VĂN BẢN GỢI Ý -->
      <li nz-submenu nzTitle="{{'van_ban_goi_y' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="editor-field my-0">
          <div class="editor-field-body">
            <div class="field-row my-0">
              <!-- Nội dung chữ -->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea style="height:80px;background: #edf6fd;
                    padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                    border-top-right-radius:5px" matInput [(ngModel)]="config['tooltip']"
                    (blur)="updateConfig()"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle=" {{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
          
        </div>
      </li>
    </ul>
  </ng-container>
</div>